import React, { useState, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import NavigationMenu from "./navigationMenu.json";
import { color } from "framer-motion";

function Navigation({ user, logout, userData, isWalkIn }) {
  const location = useLocation();
  const [isCareerOpen, setCareerOpen] = useState(false);
  const [isMenuOpen, setMenuVisible] = useState(false);

  const profile = useMemo(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const data = JSON.parse(storedUser);
      return data.username.charAt(0).toUpperCase();
    }
    return "";
  }, []);

  const profileButton = () => {
    const isProfile = !userData && !profile;
    return isProfile ? (
      <div className="d-flex gap-3 order-sm-1">
        <Link
          to="/signup"
          className="btn text-white rounded-5 ps-5 pe-5 fw-bold"
          style={{ fontSize: `0.9rem`, backgroundColor: "#D18237" }}
        >
          Sign Up
        </Link>
        <Link
          to="/signin"
          className="btn text-white rounded-5 ps-5 pe-5 fw-bold"
          style={{ fontSize: `0.9rem`, backgroundColor: "#256F22" }}
        >
          Login
        </Link>
      </div>
    ) : (
      <div className="d-flex gap-3 order-sm-1 position-relative">
        <div className="position-relative">
          <div
            className="rounded-circle d-flex align-items-center justify-content-center"
            style={{
              width: "50px",
              height: "50px",
              cursor: "pointer",
              backgroundColor: "#d18237",
            }}
            onClick={() => setMenuVisible(!isMenuOpen)}
          >
            <p className="text-white m-0 fw-bold fs-5">{profile}</p>
          </div>

          {isMenuOpen && (
            <div
              className="position-absolute bg-white shadow-sm p-2 rounded"
              style={{
                top: "65px",
                left: "40%",
                transform: "translateX(-50%)",
                minWidth: "150px",
                zIndex: 10,
              }}
            >
              <button
                className="btn text-danger w-100 fw-bold"
                onClick={() => {
                  setMenuVisible(false);
                  logout();
                }}
              >
                Log Out
              </button>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <nav
      className="navbar navbar-expand-lg navbar-light shadow-sm fixed-top"
      style={{ backgroundColor: "#FFFFFF" }}
    >
      <div className="container-fluid px-5 py-1">
        <Link
          className="navbar-brand d-md-hidden"
          to="/"
          style={{ width: "12rem" }}
        >
          <img src="/lgs.jpeg" alt="Company Logo" className="w-100" />
        </Link>

        {isWalkIn ? (
          profileButton()
        ) : (
          <>
            <button className="navbar-toggler" type="button">
              <span className="navbar-toggler-icon"></span>
            </button>

            <div
              className="collapse navbar-collapse justify-content-center"
              id="navbarNav"
            >
              <ul
                className="navbar-nav justify-content-center"
                style={{ gap: "4rem" }}
              >
                {NavigationMenu.map((item, index) => {
                  const isActive =
                    location.pathname === item.path ||
                    (item.dropdown &&
                      item.dropdown.some(
                        (subItem) => location.pathname === subItem.path
                      ));

                  return (
                    <li
                      key={index}
                      className={`nav-item ${
                        item.dropdown ? "dropdown position-relative" : ""
                      }`}
                      onMouseEnter={() => item.dropdown && setCareerOpen(true)}
                      onMouseLeave={() => item.dropdown && setCareerOpen(false)}
                    >
                      <Link
                        className="nav-link fw-bold"
                        to={item.path}
                        style={{
                          fontSize: `0.9rem`,
                          ...(item.style || {}),
                          color: isActive ? "#256F22" : "#B5B5B5",
                        }}
                      >
                        {item.name}
                      </Link>

                      {item.dropdown && isCareerOpen && (
                        <ul
                          className="bg-white text-start shadow-sm border border-1 list-unstyled position-absolute d-block"
                          style={{ right: "-100%", cursor: "pointer" }}
                        >
                          {item.dropdown.map((subItem, subIndex) => (
                            <li
                              key={subIndex}
                              className="border border-1 hover-bg"
                            >
                              <Link
                                className="dropdown-item py-3 px-4 fw-bold"
                                to={subItem.path}
                                style={{
                                  fontSize: `0.8rem`,
                                  color:
                                    location.pathname === subItem.path
                                      ? "#256F22"
                                      : "",
                                }}
                              >
                                {subItem.name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
            {profileButton()}
          </>
        )}
      </div>
    </nav>
  );
}

export default Navigation;

// import React, { useState, useMemo } from "react";
// import { Link, useLocation } from "react-router-dom";
// import NavigationMenu from "./navigationMenu.json";

// function Navigation({ user, logout, userData, isWalkIn }) {
//   const location = useLocation();
//   const [isCareerOpen, setCareerOpen] = useState(false);
//   const [isMenuOpen, setMenuVisible] = useState(false);
//   const [isNavOpen, setNavOpen] = useState(false); // Menu toggle state

//   const profile = useMemo(() => {
//     const storedUser = localStorage.getItem("user");
//     if (storedUser) {
//       const data = JSON.parse(storedUser);
//       return data.username.charAt(0).toUpperCase();
//     }
//     return "";
//   }, []);

//   // Function to toggle navigation menu
//   const handleNavToggle = () => {
//     setNavOpen(!isNavOpen);
//   };

//   // Function to handle user profile button
//   const profileButton = () => {
//     const isProfile = !userData && !profile;

//     return isProfile ? (
//       <div></div> // Empty div when no profile data
//     ) : (
//       <div className="d-flex gap-3 order-sm-1 position-relative">
//         <div className="position-relative">
//           <div
//             className="rounded-circle d-flex align-items-center justify-content-center"
//             style={{
//               width: "50px",
//               height: "50px",
//               cursor: "pointer",
//               backgroundColor: "#d18237",
//             }}
//             onClick={() => setMenuVisible(!isMenuOpen)}
//           >
//             <p className="text-white m-0 fw-bold fs-5">{profile}</p>
//           </div>

//           {isMenuOpen && (
//             <div
//               className="position-absolute bg-white shadow-sm p-2 rounded"
//               style={{
//                 top: "65px",
//                 left: "40%",
//                 transform: "translateX(-50%)",
//                 minWidth: "150px",
//                 zIndex: 10,
//               }}
//             >
//               <button
//                 className="btn text-danger w-100 fw-bold"
//                 onClick={() => {
//                   setMenuVisible(false);
//                   logout();
//                 }}
//               >
//                 Log Out
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     );
//   };

//   return (
//     <nav
//       className="navbar navbar-expand-lg navbar-light shadow-sm fixed-top"
//       style={{ backgroundColor: "#FFFFFF" }}
//     >
//       <div className="container-fluid px-5 py-1">
//         {/* Company Logo */}
//         <Link
//           className="navbar-brand d-md-hidden"
//           to="/"
//           style={{ width: "12rem" }}
//         >
//           <img src="/lgs.jpeg" alt="Company Logo" className="w-100" />
//         </Link>

//         {/* Toggle Profile Button for Walk-in Users */}
//         {isWalkIn ? (
//           profileButton()
//         ) : (
//           <>
//             {/* Navbar Toggle Button */}
//             <button
//               className="navbar-toggler"
//               type="button"
//               onClick={handleNavToggle}
//             >
//               <span className="navbar-toggler-icon"></span>
//             </button>

//             {/* Navbar Menu */}
//             <div
//               className={`collapse navbar-collapse justify-content-center ${
//                 isNavOpen ? "show" : ""
//               }`}
//               id="navbarNav"
//             >
//               <ul
//                 className="navbar-nav justify-content-center"
//                 style={{ gap: "4rem" }}
//               >
//                 {NavigationMenu.map((item, index) => {
//                   const isActive =
//                     location.pathname === item.path ||
//                     (item.dropdown &&
//                       item.dropdown.some(
//                         (subItem) => location.pathname === subItem.path
//                       ));

//                   return (
//                     <li
//                       key={index}
//                       className={`nav-item ${
//                         item.dropdown ? "dropdown position-relative" : ""
//                       }`}
//                       onMouseEnter={() => item.dropdown && setCareerOpen(true)}
//                       onMouseLeave={() => item.dropdown && setCareerOpen(false)}
//                     >
//                       <Link
//                         className="nav-link fw-bold"
//                         to={item.path}
//                         style={{ color: isActive ? "#256F22" : "#B5B5B5" }}
//                       >
//                         {item.name}
//                       </Link>

//                       {/* Dropdown Menu */}
//                       {item.dropdown && isCareerOpen && (
//                         <ul
//                           className="bg-white text-start shadow-sm border border-1 list-unstyled position-absolute d-block"
//                           style={{ right: "-100%", cursor: "pointer" }}
//                         >
//                           {item.dropdown.map((subItem, subIndex) => (
//                             <li
//                               key={subIndex}
//                               className="border border-1 hover-bg"
//                             >
//                               <Link
//                                 className="dropdown-item py-3 px-4 fw-bold"
//                                 to={subItem.path}
//                                 style={{
//                                   color:
//                                     location.pathname === subItem.path
//                                       ? "#256F22"
//                                       : "",
//                                 }}
//                               >
//                                 {subItem.name}
//                               </Link>
//                             </li>
//                           ))}
//                         </ul>
//                       )}
//                     </li>
//                   );
//                 })}
//               </ul>
//             </div>

//             {/* Profile Button */}
//             {profileButton()}
//           </>
//         )}
//       </div>
//     </nav>
//   );
// }

// export default Navigation;

// import React, { useState, useMemo } from "react";
// import { Link, useLocation } from "react-router-dom";
// import NavigationMenu from "./navigationMenu.json";

// function Navigation({ user, logout, userData, isWalkIn }) {
//   const location = useLocation();
//   const [isCareerOpen, setCareerOpen] = useState(false);
//   const [isMenuOpen, setMenuVisible] = useState(false);
//   const [isNavOpen, setNavOpen] = useState(false); // Menu toggle state

//   const profile = useMemo(() => {
//     const storedUser = localStorage.getItem("user");
//     if (storedUser) {
//       const data = JSON.parse(storedUser);
//       return data.username.charAt(0).toUpperCase();
//     }
//     return "";
//   }, []);

//   // Function to toggle navigation menu
//   const handleNavToggle = () => {
//     setNavOpen(!isNavOpen);
//   };

//   // Function to handle user profile button
//   const profileButton = () => {
//     const isProfile = !userData && !profile;

//     return isProfile ? (
//       <div></div> // Empty div when no profile data
//     ) : (
//       <div className="d-flex gap-3 order-sm-1 position-relative">
//         <div className="position-relative">
//           <div
//             className="rounded-circle d-flex align-items-center justify-content-center"
//             style={{
//               width: "50px",
//               height: "50px",
//               cursor: "pointer",
//               backgroundColor: "#d18237",
//             }}
//             onClick={() => setMenuVisible(!isMenuOpen)}
//           >
//             <p className="text-white m-0 fw-bold fs-5">{profile}</p>
//           </div>

//           {isMenuOpen && (
//             <div
//               className="position-absolute bg-white shadow-sm p-2 rounded"
//               style={{
//                 top: "65px",
//                 left: "40%",
//                 transform: "translateX(-50%)",
//                 minWidth: "150px",
//                 zIndex: 10,
//               }}
//             >
//               <button
//                 className="btn text-danger w-100 fw-bold"
//                 onClick={() => {
//                   setMenuVisible(false);
//                   logout();
//                 }}
//               >
//                 Log Out
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     );
//   };

//   return (
//     <nav
//       className="navbar navbar-expand-lg navbar-light shadow-sm fixed-top"
//       style={{ backgroundColor: "#FFFFFF" }}
//     >
//       <div className="container-fluid px-5 py-1">
//         {/* Company Logo */}
//         <Link
//           className="navbar-brand d-md-hidden"
//           to="/"
//           style={{ width: "12rem" }}
//         >
//           <img src="/lgs.jpeg" alt="Company Logo" className="w-100" />
//         </Link>

//         {/* Toggle Profile Button for Walk-in Users */}
//         {isWalkIn ? (
//           profileButton()
//         ) : (
//           <>
//             {/* Navbar Toggle Button */}
//             <button
//               className="navbar-toggler"
//               type="button"
//               onClick={handleNavToggle}
//             >
//               <span className="navbar-toggler-icon"></span>
//             </button>

//             {/* Navbar Menu - Centered on Mobile */}
//             <div
//               className={`collapse navbar-collapse ${
//                 isNavOpen ? "show" : ""
//               } justify-content-center text-center`}
//               id="navbarNav"
//             >
//               <ul className="navbar-nav">
//                 {NavigationMenu.map((item, index) => {
//                   const isActive =
//                     location.pathname === item.path ||
//                     (item.dropdown &&
//                       item.dropdown.some(
//                         (subItem) => location.pathname === subItem.path
//                       ));

//                   return (
//                     <li key={index} className="nav-item">
//                       <Link
//                         className="nav-link fw-bold"
//                         to={item.path}
//                         style={{ color: isActive ? "#256F22" : "#B5B5B5" }}
//                       >
//                         {item.name}
//                       </Link>
//                     </li>
//                   );
//                 })}
//               </ul>
//             </div>

//             {/* Profile Button */}
//             {profileButton()}
//           </>
//         )}
//       </div>
//     </nav>
//   );
// }

// export default Navigation;
